// extracted by mini-css-extract-plugin
module.exports = {"smallerAvatar":"Tile_smallerAvatar__1q9QI","dots":"Tile_dots__3vTlB"};